import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'senderEmails' })
export class SenderEmailsPipe implements PipeTransform {
  transform(users: any[]): string {
    return users.map(u => u.email).join(' ')
  }
}
